// extracted by mini-css-extract-plugin
export var cardLayout = "_1t-1";
export var paginationContainer = "_1t-0";